import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import TextDate from "components/text/TextDate";
import TextAmount from 'components/text/TextAmount';
import TransactionKeyTag from 'calculator/components/TransactionKeyTag';
import PaymentOrderTag from 'calculator/components/PaymentOrderTag';
import PaymentBlankTag from 'calculator/components/PaymentBlankTag';
import TextPercent from 'components/text/TextPercent';

const AllocateResultList = ({ title, data }) => {
    let lines = data;
    if (!lines){
      return (<div/>);
    }
    console.debug("Render");
    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="18" className="text-left">
              <span className="calc-setting-table-header">{title}</span>
            </th>
          </tr>
          <tr>
            <th className="no-right-border text-left">Færslul.</th>
            <th className="no-left-border no-right-border text-left">#</th>
            <th className="no-left-border no-right-border text-left">Heiti</th>
            <th className="no-left-border no-right-border text-left">Tímabil útreiknings</th>
            <th className="no-left-border no-right-border text-left">hlutfall / %</th>
            <th className="no-left-border no-right-border text-left">Dagafj.</th>
            <th className="no-left-border no-right-border text-right">Reiknað af</th>
            <th className="no-left-border no-right-border text-right">Upphæð</th>
            <th className="no-left-border no-right-border text-right">&nbsp;</th>
            <th className="no-left-border no-right-border text-right">Samningsv.</th>
            <th className="no-left-border no-right-border text-right">&nbsp;</th>
            <th className="no-left-border no-right-border text-right">Dráttarvextir</th>
            <th className="no-left-border no-right-border text-right">&nbsp;</th>
            <th className="no-left-border no-right-border text-right">VSK</th>
            <th className="no-left-border no-right-border text-right">&nbsp;</th>
            <th className="no-left-border no-right-border text-right">FTS</th>
            <th className="no-left-border no-right-border text-right">&nbsp;</th>
          </tr>
          </thead>
          <tbody>
          {lines.map((item,i) => {
            return(
              <tr key={i} className={item.rowDetail.rowColor}>
                <td className="no-right-border">{item.transactionKey}
                  {(item.transactionKeyDetail && item.transactionKeyDetail.calculateInterest) && <TransactionKeyTag color={'#ff0000'} type={'D'} description={'Dráttavextir'}/>}
                  {(item.transactionKeyDetail && item.transactionKeyDetail.calculateVat) && <TransactionKeyTag color={'#ff00ff'} type={'V'} description={'VSK'}/>}
                  {(item.transactionKeyDetail && item.transactionKeyDetail.natureType === 1) && <TransactionKeyTag color={'#0000ff'} type={'Á'} description={'Áfallinn'}/>}
                  {(item.transactionKeyDetail && item.transactionKeyDetail.natureType === 2) && <TransactionKeyTag color={'#0000ff'} type={'Ú'} description={'Útlagður'}/>}
                </td>
                <td className="no-left-border no-right-border ">
                  {item.itemType === 9 && <PaymentBlankTag boxtype={'round'} color={item.rowDetail.boxColor} text={item.transactionNumber} />}
                  {item.paymentNumber}</td>
                 <td className="no-left-border no-right-border ">{item.name}</td>
                 <td className="no-left-border no-right-border">{item.fromDate && <TextDate value={item.fromDate}/>} {item.toDate ? '-' : '' } {item.toDate && <TextDate value={item.toDate}/>} </td>
                 <td className="no-left-border no-right-border text-right ">
                    {(item.itemType === 12) && <span><TextAmount value={item.indexFrom}/> - <TextAmount value={item.indexTo}/></span>}
                    {(item.pointRate && item.itemType !== 12) && <span><TextPercent value={item.pointRate}/></span>}
                 </td>
                 <td className="no-left-border no-right-border ">{item.interestDays}</td>
                 <td className="no-left-border no-right-border text-right">
                    {(item.itemType !== 11 && item.itemType !== 13) && <span><TextAmount value={item.fromAmount}/></span>}
                 </td>
                 <td className="no-left-border no-right-border text-right"><TextAmount value={item.amount}/></td>
                 <td className="paymentColumnMaxLength no-left-border no-right-border text-left ">
                    {[1,7,8,6,12].indexOf(item.itemType) > -1 && <PaymentOrderTag payments={item.paymentLines}/>}
                 </td>
                 <td className="no-left-border no-right-border text-right"><TextAmount value={item.contractInterest}/></td>
                 <td className="paymentColumnMaxLength no-left-border no-right-border text-left">
                    {[2].indexOf(item.itemType) > -1 && <PaymentOrderTag payments={item.paymentLines}/>}
                 </td>
                 <td className="no-left-border no-right-border text-right"><TextAmount value={item.penaltyInterest}/></td>
                 <td className="paymentColumnMaxLength no-left-border no-right-border text-left">
                    {[3].indexOf(item.itemType) > -1 && <PaymentOrderTag payments={item.paymentLines}/>}
                 </td>
                 <td className="no-left-border no-right-border text-right"><TextAmount value={item.vat}/></td>
                 <td className="paymentColumnMaxLength no-left-border no-right-border text-left">
                    {[4].indexOf(item.itemType) > -1 && <PaymentOrderTag payments={item.paymentLines}/>}
                 </td>
                 <td className="no-left-border no-right-border text-right"><TextAmount value={item.capitalGainsTax}/></td>
                 <td className="paymentColumnMaxLength no-left-border no-right-border text-left">
                    {[5].indexOf(item.itemType) > -1 && <PaymentOrderTag payments={item.paymentLines} boxType={'circle'}/>}
                 </td>
              </tr>)
          })}
          </tbody>
        </table>
      </div>
    );  
}

AllocateResultList.propTypes = {
    title : PropTypes.string,
    data: PropTypes.array,
};



export default AllocateResultList;
